<template>
    <nav v-if="alreadyToInit">
        <pagination
            @range-change="rangeChange"
            @page-change="pageChange"
            :total-items="totalItems"
            :max-visible-pages="maxVisiblePages"
            :items-per-page="itemsPerPage"
            :page="page"
        >
            <template slot="buttons" slot-scope="props">
                <page-button
                    v-for="(button, key) in props.buttons"
                    :key="key"
                    v-bind="button"
                    @page-change="page = button.page"
                />
            </template>
        </pagination>
    </nav>
</template>

<script>
import Pagination from '@/components/paginator/Pagination'
import PageButton from '@/components/paginator/PageButton'
import Url from '@/service/url'

export default {
    name: 'paginator',

    components: {
        PageButton,
        Pagination
    },

    props: {
        pageCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number
        },
        totalItems: {
            type: Number
        },
        itemsPerPage: {
            type: Number,
            default: 25
        }
    },

    data() {
        return {
            start: null,
            end: null,
            maxVisiblePages: 4,
            page: 0,
            alreadyToInit: false
        }
    },

    watch: {
        $route() {
            var url = new Url()
            const initPage = url.getQuery().page || 1
            this.page = parseInt(initPage) - 1
        }
    },

    mounted() {
        var url = new Url()
        const initPage = url.getQuery().page || 1
        this.page = parseInt(initPage) - 1

        this.alreadyToInit = true
    },

    methods: {
        pageChange(page) {
            this.page = page

            this.$emit('change', page + 1)
        },

        rangeChange(start, end) {
            this.start = start
            this.end = end
        },

        setPage(page) {
            this.page = page
        }
    }
}
</script>

<style lang="scss">
.pagination {
    .page-item {
        cursor: pointer;

        &.active,
        &.disabled {
            cursor: default;
        }

        &:first-child {
            .page-link {
                margin-left: 0;
                border-top-left-radius: 0.25rem;
                border-bottom-left-radius: 0.25rem;
            }
        }
        &:last-child {
            .page-link {
                border-top-right-radius: 0.25rem;
                border-bottom-right-radius: 0.25rem;
            }
        }

        &.active .page-link {
            z-index: 1;
            color: white;
            background-color: var(--color-primary);
            border-color: var(--color-primary);
            pointer-events: none;
            cursor: auto;
        }

        &.disabled .page-link {
            border-color: transparent;
            background-color: white;
            color: var(--color-primary);
            opacity: 0.6;
            pointer-events: none;
            cursor: auto;
        }

        .page-link {
            color: var(--color-primary);
            border-radius: 3px;
            margin: 0 3px;
            border-color: transparent;
            background-color: white;
            font-weight: 600;
            transition: all 0.5s;
            box-shadow: 0 0 10px rgba(66, 66, 66, 0.1);
            &:hover {
                background-color: var(--color-primary);
                color: white;
                border-color: transparent;
            }
        }
    }
}
</style>
